import { ILocalizationState } from './localizationContext';
import { LocalizationActionsTypes, TLocalizationAction } from './localizationActions';

export const localizationReducer = (state: ILocalizationState, action: TLocalizationAction): ILocalizationState => {
	switch (action.type) {
		case LocalizationActionsTypes.REFETCH_WORDINGS:
			return {
				...state,
				needRefetchWordings: action.payload.needRefetch,
			};
		case LocalizationActionsTypes.SET_ALL_DATA:
			return {
				...state,
				groups: action.payload.groups,
			};
		case LocalizationActionsTypes.SET_GROUP:
			return {
				...state,
				selectedGroup: action.payload.group,
			};
		case LocalizationActionsTypes.SET_LANGUAGE:
			return {
				...state,
				selectedLanguage: action.payload.language,
			};
		case LocalizationActionsTypes.REMOVE_WORDING:
			return {
				...state,
				groups: action.payload.updatedGroups,
			};
		case LocalizationActionsTypes.ADD_INVALID_FIELD:
			return {
				...state,
				invalidFields: [...state.invalidFields, action.payload.invalidField],
			};
		case LocalizationActionsTypes.CLEAR_INVALID_FIELDS:
			return {
				...state,
				invalidFields: [],
			};
		case LocalizationActionsTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case LocalizationActionsTypes.SET_DELETE_WORDING_DATA:
			return {
				...state,
				deleteWordingData: action.payload.deleteWordingData,
			};
		case LocalizationActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case LocalizationActionsTypes.CHANGE_MODE:
			return {
				...state,
				mode: action.payload.mode,
			};
		default:
			return state;
	}
};
